/* eslint-disable no-param-reassign */
const axios = require('axios');
const { deleteEmptyStrings } = require('Shared/utils/UtilsHelper');

/**
 * This class is expected to provide an instance of axios client at runtime. Subclasses
 * may set any additional needed configuration.
 */
class AxiosClient {
    /**
     *
     * @param {string} url baseURL of axios instance.
     */
    constructor(url = '') {
        if (url) {
            this.url = url;
        }
    }

    initializeInterceptor() {
        this.instance.interceptors.request.use((config) => {
            if (config.method === 'get' && config.params?.cleanEmptyStrings) {
                config.params = deleteEmptyStrings(config.params);
                delete config.params.cleanEmptyStrings;
            }

            return config;
        }, error => Promise.reject(error));
    }

    /**
     * Allows modifying the baseURL of axios instance at runtime.
     *
     * @param {string} url the new baseURL
     */
    setUrl(url) {
        this.url = url;
    }

    /**
     *
     * @returns the axios instance
     */
    getInstance() {
        return this.instance;
    }
}

class KubeClient extends AxiosClient {
    constructor() {
        super();
        this.instance = axios.create({ baseURL: API_URL });
        super.initializeInterceptor();
    }
}

class SwitchClient extends AxiosClient {
    constructor() {
        super();
        this.instance = axios.create({ baseURL: SWITCH_URL });
        super.initializeInterceptor();
    }
}

class EchoClient extends AxiosClient {
    constructor(url) {
        super(url);
        this.instance = axios.create({ baseURL: this.url || ECHO_API_URL });
    }

    setUrl(url) {
        super.setUrl(url);
        this.instance = axios.create({ baseURL: this.url });
    }
}

module.exports = {
    AxiosClient,
    KubeClient,
    EchoClient,
    SwitchClient,
};
